import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {JourneyService} from '../service/journey.service';
import {JourneyDelegateTemplateModel, JourneyPageModel} from '../models/journey-page.model';
import {fadeInOnEnterAnimation} from 'angular-animations';
import {AuthService} from '../../../services/auth.service';
import {UserInfoModel} from '../../../services/models/user-info.model';
import {UserService} from '../../../services/user.service';
import {AlertController, IonSlides, LoadingController} from '@ionic/angular';
import {AnalyticsService} from '../../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';
import {EventsService} from '../../../services/events.service';
import {environment} from '../../../../environments/environment';
import {NavService} from '../../../services/nav.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-learning-journey-page',
    templateUrl: './journey-page.component.html',
    styleUrls: ['./journey-page.component.scss'],
    animations: [fadeInOnEnterAnimation({anchor: 'enter', duration: 300})]
})
export class JourneyPage implements OnInit {

    @ViewChild(IonSlides, {static: true, read: IonSlides}) slides: IonSlides;

    subscriptions: Subscription[] = [];

    backRoute: any[] = ['/home'];
    currentStage = 1;
    countStage = 1;
    emptyArray = [];
    stagesPerPage = 9;
    stageArray = [1];
    stageActiveArray = [];
    stageActiveArrayValid = false;
    isSaveList = false;
    isSaveProgram = false;

    loading = null;

    customListData: Array<any> = [];

    isFirstLoad = true;
    isLoading = false;
    loadingStep = null;
    pageData: JourneyPageModel[] = [];
    saveForm = false;

    userTemplate: JourneyDelegateTemplateModel = null;
    userInfo: UserInfoModel = null;
    userInfoValid = false;

    slidesTotal = 0;
    slideCurrent = -1;

    platform = 'website';
    theme = 'default';

    socialIcon = false;
    leaderboardIcon = false;

    // Optional parameters to pass to the swiper instance.
    // See http://idangero.us/swiper/api/ for valid options.
    slideOpts = {
        shortSwipes: true,
        longSwipes: true
    };

    constructor(
        private journeyService: JourneyService,
        private activatedRoute: ActivatedRoute,
        private analytics: AnalyticsService,
        public userService: UserService,
        private authService: AuthService,
        private alertController: AlertController,
        private translate: TranslateService,
        private event: EventsService,
        private router: Router,
        private nav: NavService,
        private loadingCtrl: LoadingController
    ) {
        this.platform = environment.platform;
        this.theme = environment.theme;

        this.subscriptions.push(
            this.event.subscribe('e-learning:getMyElearningReport:forceUpdate', (payload) => {
                if (!!payload.status) {
                    const stepIndex = this.stageActiveArray.indexOf(this.currentStage);
                    for (let i = stepIndex; i < this.pageData.length; i++) {
                        this.pageData[i] = null
                    }
                }
            })
        );

        this.subscriptions.push(
            this.event.subscribe('tasks:updateTaskClick', (task) => {
                const stepIndex = this.stageActiveArray.indexOf(this.currentStage);
                if (this.pageData[stepIndex] !== null) {
                    let data = this.pageData[stepIndex];
                    if (data.stage.details.type === 'list') {
                        const j = data.details.list.findIndex((t) => t.id === task.id);
                        let updated = false;
                        for (let i = j + 1; i < data.details.list.length; i++) {
                            if (data.details.list[i].task) {
                                console.log('tasks:enableTaskForRun', data.details.list[i]);
                                this.event.subscribe('tasks:enableTaskForRun', (data.details.list[i]));
                                data.details.list[i].disabled = false;
                                updated = true;
                                break;
                            }
                        }
                        if (!updated) {
                            for (let i = stepIndex+1; i < this.pageData.length; i++) {
                                this.pageData[i] = null
                            }
                        }
                    }
                }
            })
        );

        this.subscriptions.push(
            this.event.subscribe('form:saved', (payload) => {
                if (payload.hasOwnProperty('name') && ['skills-checker', 'journeyStage'].includes(payload.name)) {
                    this.reloadPageData(true);
                }
            })
        );
    }

    ionViewWillEnter() {
        const stepIndex = this.stageActiveArray.indexOf(this.currentStage);
        if (this.userInfo !== null && this.pageData[stepIndex] === null) {
            this.initPageData(this.currentStage);
        }
    }

    ngOnInit() {
        if (this.platform === 'website') {
            this.slideOpts = {
                shortSwipes: false,
                longSwipes: true
            };
        }

        let template_id = parseInt(this.activatedRoute.snapshot.paramMap.get('template_id'), 10);
        let step = parseInt(this.activatedRoute.snapshot.paramMap.get('step'), 10);
        if (isNaN(step) || step < 1) {
            step = 1;
        }

        if (!isNaN(template_id) && template_id > 0) {
            this.userService.setUserDelegateTemplate(template_id)
        }

        this.currentStage = step;

        this.userInfo = this.userService.getCurrentUserInfo(false);
        if (this.userInfo !== null) {
            this.initStepper();
        } else {
            this.userService.getUserInfo()
                .then((userInfo) => {
                    this.userInfo = userInfo;
                    this.initStepper();
                });
        }
    }

    initStepper() {
        this.userTemplate = this.userService.getUserDelegateTemplate();
        this.socialIcon = this.authService.getUserCompanyEnabledSocial();
        this.leaderboardIcon = this.authService.getUserCompanyEnabledLeaderboard();
        this.backRoute = this.nav.getHomeCommand();

        this.stageActiveArray = this.userTemplate.stages.active;
        this.countStage = this.userTemplate.stages.total;

        if (!this.stageActiveArray.length) {
            this.nav.navigateHome();
            return false;
        }

        this.slidesTotal = this.stageActiveArray.length;
        if (this.stageActiveArray.indexOf(this.currentStage) < 0) {
            this.currentStage = this.stageActiveArray[0];
        }

        const iterator: IterableIterator<number> = Array(this.countStage).keys();
        this.stageArray = Array.from(iterator).map(i => i + 1);
        this.pageData = Array.from(this.stageActiveArray).map(i => null);
        this.stageActiveArrayValid = true;

        const emptyStages = this.stagesPerPage - this.stageArray.length % this.stagesPerPage;
        if (emptyStages < this.stagesPerPage) {
            this.emptyArray = new Array(emptyStages).fill(0);
        }

        if (this.stageActiveArray.indexOf(this.currentStage) === 0) {
            this.initPageData(this.currentStage);
        } else {
            this.goToStage(this.currentStage);
        }
    }

    initPageData(step) {
        this.analytics.trackView('My Journey - Stage ' + step);

        const stepIndex = this.stageActiveArray.indexOf(step);
        if (this.pageData[stepIndex] === null && !(this.isLoading && this.loadingStep === step)) {
            this.isLoading = true;
            this.loadingStep = step;
            this.journeyService.getPageData(step, this.userTemplate.template_id)
                .then(data => {
                    this.isLoading = false;
                    this.isFirstLoad = false;
                    if (!!data) {
                        const currentStageIndex = this.stageActiveArray.indexOf(data.stage.current);
                        this.pageData[currentStageIndex] = data;

                        // If we are on another slide - skip this step
                        if (step !== this.currentStage) {
                            return false;
                        }

                        this.currentStage = data.stage.current;
                        if (step !== this.currentStage) {
                            this.goToStage(this.currentStage);
                            return false;
                        }
                    } else {
                        this.nav.navigateHome();
                        return false;
                    }
                });
        }
    }

    goToStage(step: number) {
        this.nav.action(() => {
            if (this.stageActiveArray.indexOf(step) >= 0) {
                this.discardChanges();
                this.currentStage = step;
                this.slideCurrent = this.stageActiveArray.indexOf(step) + 1;
                this.slides.slideTo(this.slideCurrent - 1).then(() => {
                    this.slideDataPrepare();
                });
            }
        });
    }

    slideDidLoad(event) {
        event.target.style.height = 'calc(100% - ' + event.target.offsetTop + 'px)';
    }

    slideChanged(event) {
        this.slideDataPrepare();
    }

    slideDataPrepare() {
        this.slides.getActiveIndex().then((index) => {
            this.slideCurrent = index + 1;
            this.currentStage = this.stageActiveArray[index];
            this.initPageData(this.currentStage);
        });
    }

    isCurrentDecade(step) {
        return Math.floor((step - 1) / this.stagesPerPage) === Math.floor((this.currentStage - 1) / this.stagesPerPage);
    }

    isLastInDecade(step) {
        return step % this.stagesPerPage === 0;
    }

    getNextPageStage() {
        const nextPageStage = (Math.floor((this.currentStage - 1) / this.stagesPerPage) + 1) * this.stagesPerPage + 1;
        return this.stageActiveArray.find((stage) => stage >= nextPageStage);
    }

    nextPage() {
        const nextPageStage = this.getNextPageStage();
        if (nextPageStage >= 0) {
            this.goToStage(nextPageStage);
        }
    }

    getPrevPageStage() {
        const prevPageStage = Math.floor((this.currentStage - 1) / this.stagesPerPage) * this.stagesPerPage;
        const index = this.stageActiveArray.findIndex((stage) => stage > prevPageStage);
        return this.stageActiveArray[index - 1];
    }

    prevPage() {
        const prevPageStage = this.getPrevPageStage();
        if (prevPageStage >= 0) {
            this.goToStage(prevPageStage);
        }
    }

    next(boolean) {
        if (!boolean) { return; }
        this.nav.action(() => {
            this.discardChanges();
            this.slides.slideNext();
        });
    }

    prev(boolean) {
        if (!boolean) { return; }
        this.nav.action(() => {
            this.discardChanges();
            this.slides.slidePrev();
        });
    }

    onSave() {
        this.saveForm = false;
        setTimeout(() => {
            this.saveForm = true;
            this.isSaveProgram = false;
            this.slides.lockSwipes(false);
        });
    }

    discardChanges() {
        this.slides.lockSwipes(false);
        if (this.isSaveProgram) {
            this.isSaveProgram = false;
            this.reloadPageData();
        }

        if (this.isSaveList) {
            this.isSaveList = false;
            this.customListData = [];
            this.reloadPageData();
        }
    }

    reloadPageData(initPageData = false) {
        const currentStageIndex = this.stageActiveArray.indexOf(this.currentStage);
        this.pageData[currentStageIndex] = null;
        if (initPageData) {
            console.log('reloadPageData > initPageData')
            this.initPageData(this.currentStage);
        }
    }

    onChangeProgramSaveButton(value) {
        this.slides.lockSwipes(true);
        this.isSaveProgram = true;
    }

    onChangeListSaveButton(value) {
        this.slides.lockSwipes(true);
        this.event.publish('form:changed', 'journey:stage');
        this.customListData = this.customListData.filter(item => item.section_id !== value.section_id);
        this.customListData.push(value);
        this.isSaveList = true;
    }

    onSaveList() {
        if (this.customListData.length === 0) {
            this.event.publish('form:saved', {name: 'journeyStage'});
            this.slides.lockSwipes(false);
            return false;
        }

        this.showLoading();
        this.journeyService.savePageData(this.customListData)
            .then(responce => {
                this.loading.dismiss()

                if (responce !== null) {
                    this.event.publish('form:saved', {name: 'journeyStage'});
                    this.slides.lockSwipes(false);

                    this.isSaveList = false;
                    this.customListData = [];

                    this.alertController.create({
                        header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                        message: this.translate.instant(responce.message),
                        buttons: [this.translate.instant('__ALERT_SUCCESS_BUTTON__')]
                    }).then(a => a.present());
                }
            })
            .catch(e => {
                this.loading.dismiss()
            });
    }

    async showLoading() {
        this.loading = await this.loadingCtrl.create({
            message: 'Please wait...',
            duration: 1000,
            spinner: 'circles',
        });

        await this.loading.present();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
